import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import Quiz from './component/Quiz';
import { GlobalStyle, ANI_TIME, MAX_WIDTH, BACKGROUND_COLOR } from './common';
import { ElementType, IQuiz, IThink } from './type';
import styled from 'styled-components';
import { playStarAnimation, setStarPosition } from './animation';
import Modal from './component/Modal';
import Think from './component/Think';
import Event from './component/Event';
import useWindowSize from './useWindowSize';
import Credit from './component/Credit';
import Header from './component/Header';

function App() {
  // const [showEventPopup, setShowEventPopup] = useState(true);
  const [quizIndex, setQuizIndex] = useState(0);
  const [star, setStar] = useState(0);
  const [thinkItem, setThinkItem] = useState<IThink | null>(null);
  const [showNext, setShowNext] = useState(false);
  const [faceIn, setFaceIn] = useState(true);
  const [showCredit, setShowCredit] = useState(false);
  const [failCount, setFailCount] = useState(0);
  const starRef = useRef<HTMLElement>(null);
  const windowSize = useWindowSize();
  function onFail() {
    setFailCount(failCount + 1);
    const minus = quizIndex % 3;
    setQuizIndex(quizIndex - minus);
    setStar(star - minus);
    window.scrollTo(0, 0);
  }
  function onNext() {
    setFaceIn(false);
    setShowNext(true);
    setTimeout(() => {
      setFaceIn(true);
    }, 1);
    setTimeout(() => {
      setShowNext(false);
      setQuizIndex(quizIndex + 1);
    }, ANI_TIME);
    const item = THINK_LIST.find(item => item.quizIndex === quizIndex + 1);
    if (item) {
      window.scrollTo(0, 0);
      setThinkItem(item);
      if (quizIndex + 1 === MAX_QUIZ_INDEX) {
        setShowCredit(true);
        setStarPosition({ x: -100, y: -100 });
      }
    }
  }
  function setStarPositionFromEl() {
    if (starRef.current) {
      const bound = starRef.current.getBoundingClientRect();
      const x = bound.left + bound.width / 2 - 40;
      const y = bound.top + bound.height / 2 - 1;
      setStarPosition({ x, y });
    }
  }
  function increaseStar(justAni?: boolean) {
    setStarPositionFromEl();
    playStarAnimation();
    if (!justAni) {
      setStar(star + 1);
    }
  }
  useEffect(() => {
    increaseStar(true);
  }, []);
  useEffect(() => {
    setStarPositionFromEl();
  }, [windowSize.width]);
  function onCloseModal() {
    setThinkItem(null);
    window.scrollTo(0, 0);
  }
  function onStartOver() {
    setShowCredit(false);
    setQuizIndex(0);
    setStar(0);
  }
  useLayoutEffect(() => {
    setStarPositionFromEl();
  }, [showCredit]);
  return (
    <>
      {!showCredit && (
        <Header
          quizIndex={quizIndex}
          star={star}
          starRef={starRef}
          height={HEADER_HEIGHT}
        />
      )}
      {!showCredit && (
        <Container key={failCount}>
          {QUIZ_LIST.map(
            (data, index) =>
              ((quizIndex === index - 1 && showNext) ||
                quizIndex === index) && (
                <Quiz
                  key={index}
                  show={
                    (quizIndex === index - 1 && faceIn) || quizIndex === index
                  }
                  onFail={onFail}
                  onNext={onNext}
                  increaseStar={increaseStar}
                  data={data}
                />
              ),
          )}
        </Container>
      )}
      {showCredit && <Credit onStartOver={onStartOver} />}
      <GlobalStyle />
      <Modal
        isOpen={!!thinkItem}
        onRequestClose={onCloseModal}
        contentStyle={{
          margin: '10vh auto',
          height: '80vh',
          maxWidth: `${MAX_WIDTH - 60}px`,
          top: 0,
          right: '5vw',
          left: '5vw',
          bottom: undefined,
          boxSizing: 'border-box',
          textAlign: 'center',
        }}
      >
        <Think data={thinkItem} onClose={onCloseModal} />
      </Modal>
      {/* <Modal
        isOpen={showEventPopup}
        onRequestClose={() => setShowEventPopup(false)}
        contentStyle={{
          margin: 'auto',
          maxWidth: `${MAX_WIDTH - 250}px`,
          bottom: undefined,
          boxSizing: 'border-box',
          textAlign: 'center',
          backgroundColor: '#f6f6ff',
        }}
      >
        <Event onClose={() => setShowEventPopup(false)} />
      </Modal> */}
    </>
  );
}

const HEADER_HEIGHT = '64px';
export const Container = styled.div`
  max-width: ${MAX_WIDTH}px;
  height: 100vh;
  margin: ${HEADER_HEIGHT} auto 0;
  background-color: ${BACKGROUND_COLOR};
  color: white;
`;

const C_PURPLE = '#c678dd';
const C_BLUE = '#61afef';
const C_WHITE = '#abb2bf';
const C_RED = '#e06c75';
const C_ORANGE = '#d19a66';
const C_GREEN = '#98c379';
const CODE_1 = [
  { text: '<', color: C_WHITE },
  { text: 'input ', color: C_RED },
  { text: 'type', color: C_ORANGE },
  { text: '=', color: C_WHITE },
  { text: '"text"', color: C_GREEN },
  { text: ' />', color: C_WHITE },
];
const CODE_2 = [
  { text: '<', color: C_WHITE },
  { text: 'a ', color: C_RED },
  { text: 'href', color: C_ORANGE },
  { text: '={data1} />', color: C_WHITE },
];
const CODE_3 = [
  { text: 'function ', color: C_PURPLE },
  { text: 'MyComponent ', color: C_BLUE },
  { text: '({ value }) {', color: C_WHITE },
  { isNewLine: true },
  { text: 'if ', marginLeft: '20px', color: C_PURPLE },
  { text: '(value ', color: C_WHITE },
  { text: '=== ', color: C_BLUE },
  { text: '0', color: C_ORANGE },
  { text: ') {', color: C_WHITE },
  { isNewLine: true },
  { text: 'const ', marginLeft: '40px', color: C_PURPLE },
  { text: '[', color: C_WHITE },
  { text: 'num', color: C_ORANGE },
  { text: ', ', color: C_WHITE },
  { text: 'setNum', color: C_ORANGE },
  { text: ']', color: C_WHITE },
  { text: ' = useState', color: C_BLUE },
  { text: '(', color: C_WHITE },
  { text: '0', color: C_ORANGE },
  { text: '); ', color: C_WHITE },
  { text: '// 1번 코드', color: C_GREEN },
  { isNewLine: true },
  { text: '}', marginLeft: '20px', color: C_WHITE },
  { isNewLine: true },
  { text: 'for ', marginLeft: '20px', color: C_PURPLE },
  { text: '(', color: C_WHITE },
  { text: 'let ', color: C_PURPLE },
  { text: 'i ', color: C_WHITE },
  { text: '= ', color: C_BLUE },
  { text: '0', color: C_ORANGE },
  { text: '; i ', color: C_WHITE },
  { text: '< ', color: C_BLUE },
  { text: 'value; i', color: C_WHITE },
  { text: '++', color: C_BLUE },
  { text: ') {', color: C_WHITE },
  { isNewLine: true },
  { text: 'const ', marginLeft: '40px', color: C_PURPLE },
  { text: '[', color: C_WHITE },
  { text: 'num', color: C_ORANGE },
  { text: ', ', color: C_WHITE },
  { text: 'setNum', color: C_ORANGE },
  { text: ']', color: C_WHITE },
  { text: ' = useState', color: C_BLUE },
  { text: '(', color: C_WHITE },
  { text: '0', color: C_ORANGE },
  { text: '); ', color: C_WHITE },
  { text: '// 2번 코드', color: C_GREEN },
  { isNewLine: true },
  { text: '}', marginLeft: '20px', color: C_WHITE },
  { isNewLine: true },
  { text: 'function ', marginLeft: '20px', color: C_PURPLE },
  { text: 'func1', color: C_BLUE },
  { text: '() {', color: C_WHITE },
  { isNewLine: true },
  { text: 'const ', marginLeft: '40px', color: C_PURPLE },
  { text: '[', color: C_WHITE },
  { text: 'num', color: C_ORANGE },
  { text: ', ', color: C_WHITE },
  { text: 'setNum', color: C_ORANGE },
  { text: ']', color: C_WHITE },
  { text: ' = useState', color: C_BLUE },
  { text: '(', color: C_WHITE },
  { text: '0', color: C_ORANGE },
  { text: '); ', color: C_WHITE },
  { text: '// 3번 코드', color: C_GREEN },
  { isNewLine: true },
  { text: '}', marginLeft: '20px', color: C_WHITE },
  { isNewLine: true },
  { text: '// ...', marginLeft: '20px', color: C_GREEN },
  { isNewLine: true },
  { text: '}', color: C_WHITE },
];

const QUIZ_LIST: IQuiz[] = [
  [
    {
      type: ElementType.TextCode,
      data: CODE_1,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드를 브라우저 콘솔에 입력하면' },
    { type: ElementType.TextHide, data: ' 그 결과는?' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.TextMoveTo, data: 'syntax 에러가 난다.' },
    {
      type: ElementType.OptionFail,
      data: '리액트 element object가 출력된다.',
    },
    {
      type: ElementType.OptionFail,
      data: '리액트 패키지를 import하지 않아서 에러가 난다.',
    },
    { type: ElementType.OptionPass, data: 'syntax 에러가 난다.' },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_1,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드를 브라우저 콘솔에 입력하면' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'syntax 에러가 난다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '이 에러를 해결하는데 사용되는 도구는' },
    { type: ElementType.TextHide, data: '?' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.TextMoveTo, data: 'babel' },
    { type: ElementType.TextShowLast, data: '이다.' },
    {
      type: ElementType.OptionFail,
      data: 'webpack',
    },
    {
      type: ElementType.OptionPass,
      data: 'babel',
    },
    { type: ElementType.OptionFail, data: 'polyfill' },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_1,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드를 브라우저 콘솔에 입력하면' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'syntax 에러가 난다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '이 에러를 해결하는데 사용되는 도구는' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'babel이다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '다음 중 잘못된 설명은?' },
    {
      type: ElementType.OptionPass,
      data: 'babel은 런타임에 위 코드를 자바스크립트 문법으로 변환한다.',
    },
    {
      type: ElementType.OptionFail,
      data:
        'babel은 위 코드를 React.createElement 함수를 호출하는 코드로 변환한다.',
    },
    {
      type: ElementType.OptionFail,
      data: 'babel은 리액트뿐만 아니라 vue.js에서도 사용된다.',
    },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_2,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'data1의 출처로 부적절한 것은' },
    { type: ElementType.TextHide, data: '?' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.TextMoveTo, data: '컴포넌트 외부의 let 변수' },
    { type: ElementType.TextShowLast, data: '이다.' },
    {
      type: ElementType.OptionFail,
      data: '컴포넌트의 state',
    },
    {
      type: ElementType.OptionFail,
      data: '컴포넌트 외부의 const 변수',
    },
    { type: ElementType.OptionPass, data: '컴포넌트 외부의 let 변수' },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_2,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'data1의 출처로 부적절한 것은' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '컴포넌트 외부의 let 변수이다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '그 이유에 대한 설명으로 적절한 것은' },
    { type: ElementType.TextHide, data: '?' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.TextMoveTo,
      data: '리액트가 데이터의 변경 시점을 모르기 때문',
    },
    { type: ElementType.TextShowLast, data: '이다.' },
    {
      type: ElementType.OptionFail,
      data: '메모리를 효율적으로 사용할 수 없기 때문',
    },
    {
      type: ElementType.OptionFail,
      data: '렌더링 성능에 부정적인 영향을 주기 때문',
    },
    {
      type: ElementType.OptionPass,
      data: '리액트가 데이터의 변경 시점을 모르기 때문',
    },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_2,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: 'data1의 출처로 부적절한 것은' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '컴포넌트 외부의 let 변수이다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '그 이유에 대한 설명으로 적절한 것은' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data: '리액트가 데이터의 변경 시점을 모르기 때문이다.',
    },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data:
        '때로는 데이터가 변경되지 않아도 렌더 함수가 호출돼서 성능에 부정적인 영향을 준다.',
    },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data: '다음 중 이를 해결하기 위한 방법이 아닌 것은?',
    },
    {
      type: ElementType.OptionPass,
      data: '클래스 컴포넌트를 리액트 훅으로 변경하기',
    },
    {
      type: ElementType.OptionFail,
      data: 'shouldComponentUpdate 또는 React.memo 사용하기',
    },
    {
      type: ElementType.OptionFail,
      data: '렌더 함수에서 새로운 객체, 배열, 함수 생성하지 않기',
    },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_3,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '리액트 훅을 사용한 코드다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드에 대한 설명으로 옳은 것은' },
    { type: ElementType.TextHide, data: '?' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.TextMoveTo,
      data: '1, 2, 3번 모두 훅을 잘못 사용한 예다.',
    },
    {
      type: ElementType.OptionFail,
      data: '3번 코드만 훅을 잘못 사용한 예고, 나머지는 바르게 사용한 예다.',
    },
    {
      type: ElementType.OptionFail,
      data:
        '1, 2번 코드는 훅을 잘못 사용한 예고, 3번 코드는 바르게 사용한 예다.',
    },
    {
      type: ElementType.OptionPass,
      data: '1, 2, 3번 모두 훅을 잘못 사용한 예다.',
    },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_3,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '리액트 훅을 사용한 코드다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드에 대한 설명으로 옳은 것은' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '1, 2, 3번 모두 훅을 잘못 사용한 예다.' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data: '다음 중 훅의 규칙에 대한 설명으로 잘못된 것은',
    },
    { type: ElementType.TextHide, data: '?' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.TextMoveTo,
      data: '훅은 클래스 컴포넌트에서 사용될 수 있다.',
    },
    {
      type: ElementType.OptionPass,
      data: '훅은 클래스 컴포넌트에서 사용될 수 있다.',
    },
    {
      type: ElementType.OptionFail,
      data: '훅은 함수 컴포넌트에서 사용될 수 있다.',
    },
    {
      type: ElementType.OptionFail,
      data: '하나의 컴포넌트에서 훅을 호출하는 순서는 항상 같아야 한다.',
    },
  ],
  [
    {
      type: ElementType.TextCode,
      data: CODE_3,
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '리액트 훅을 사용한 코드다.' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '위 코드에 대한 설명으로 옳은 것은' },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '1, 2, 3번 모두 훅을 잘못 사용한 예다.' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data: '다음 중 훅의 규칙에 대한 설명으로 잘못된 것은',
    },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.Text,
      data: '훅은 클래스 컴포넌트에서 사용될 수 있다.',
    },
    { type: ElementType.NewLine, data: '8px' },
    { type: ElementType.Text, data: '다음 중 훅에 대한 설명으로 잘못된 것은?' },
    { type: ElementType.NewLine, data: '8px' },
    {
      type: ElementType.OptionFail,
      data:
        '훅을 사용하면 함수 컴포넌트에서도 state와 생명 주기 함수를 활용할 수 있다.',
    },
    {
      type: ElementType.OptionPass,
      data:
        '함수 컴포넌트는 인스턴스가 없으므로 클래스의 멤버 변수에 대응되는 변수를 만들 수 없다.',
    },
    {
      type: ElementType.OptionFail,
      data:
        'componentDidUpdate 메서드를 훅으로 포팅할 때는 useEffect보다 useLayoutEffect을 사용하는 게 더 안전하다.',
    },
  ],
];
const MAX_QUIZ_INDEX = QUIZ_LIST.length;

const THINK_LIST: IThink[] = [
  {
    quizIndex: 3,
    thinkTexts: [
      'babel과 polyfill은 주로 오래된 브라우저에서 최신 문법을 사용하기 위한 용도로 쓰인다.',
      '그렇다면 둘의 차이점은 무엇일까?',
    ],
    hintTexts: ['babel과 polyfill이 실행되는 시점은 각각 언제인가?'],
  },
  {
    quizIndex: 6,
    thinkTexts: [
      '리덕스와 컴포넌트 state는 불변 객체로 관리하라는 얘기을 많이 한다.',
      '그 이유를 리액트의 렌더링 성능 측면에서 설명해보자.',
    ],
    hintTexts: ['shouldComponentUpdate 또는 React.memo의 역할을 생각해보자.'],
  },
  {
    quizIndex: 9,
    thinkTexts: [
      'useWindowSize와 같은 커스텀 훅을 만들어도 기존에 작성한 클래스 컴포넌트에서는 사용할 수 없다.',
      '커스텀 훅을 클래스 컴포넌트에서도 사용하기 위해서는 어떤 작업이 필요할까?',
    ],
    hintTexts: [
      '리액트 훅이 나오기 전에 컴포넌트의 공통 로직을 분리하던 방법을 떠올려보자.',
    ],
  },
];

export default App;
